export function getCookie(name) {
	const cookieArr = document.cookie.split(';');

	for (let i = 0; i < cookieArr.length; i += 1) {
		const cookiePair = cookieArr[i].trim();

		if (cookiePair.startsWith(`${name}=`)) {
			return decodeURIComponent(cookiePair.substring(name.length + 1));
		}
	}

	return null;
}

export function findRetailerLocationCategories() {
	const retailerID = getCookie('retailerID');
	if (!retailerID) {
		return null;
	}

	const button = document.querySelector(`[data-retailer-id="${retailerID}"]`);
	if (!button) {
		return null;
	}

	return button.getAttribute('data-retailer-location-categories');
}

export function getMenuType() {
	let menuType = null;
	if (window.localStorage) {
		menuType = localStorage.getItem('cp_retailer_menu_type');
	}
	if (!menuType) {
		menuType = getCookie('menu_type');
	}
	return menuType ? String(menuType).toUpperCase() : 'RECREATIONAL';
}

export function showMatchingElements(locationCategories, menuType) {
	if (locationCategories === null || typeof locationCategories === 'undefined') {
		return;
	}

	let categoryIds = [];
	if (Array.isArray(locationCategories)) {
		categoryIds = locationCategories.map((id) => String(id).trim());
	} else if (typeof locationCategories === 'string') {
		categoryIds = locationCategories.split(',').map((id) => id.trim());
	}

	document.querySelectorAll('[data-module-location-categories]').forEach((element) => {
		const moduleCategories = element.getAttribute('data-module-location-categories') || '';
		const moduleMenuTypes = element.getAttribute('data-module-menu-type') || 'RECREATIONAL';

		const moduleCategoryIds = moduleCategories.split(',').map((id) => id.trim());
		const moduleMenuTypeList = moduleMenuTypes.split(',').map((type) => type.trim().toUpperCase());

		const matchesCategory = categoryIds.some((id) => moduleCategoryIds.includes(id));
		const matchesMenuType = moduleMenuTypeList.includes(menuType);

		element.style.display = matchesCategory && matchesMenuType ? '' : 'none';
	});
}

export function applyForRetailerId(retailerId) {
	if (!retailerId) {
		return;
	}

	let locationCategories = null;

	if (window.retailerData && Array.isArray(window.retailerData.retailers)) {
		const selectedRetailer = window.retailerData.retailers.find((retailer) => String(retailer.id) === String(retailerId));
		if (selectedRetailer && Array.isArray(selectedRetailer.location_category_ids)) {
			locationCategories = selectedRetailer.location_category_ids;
		}
	}

	if (locationCategories === null) {
		locationCategories = findRetailerLocationCategories();
	}

	showMatchingElements(locationCategories, getMenuType());
}

export function initNavLocationCategories() {
	applyForRetailerId(getCookie('retailerID'));

	document.addEventListener('retailerUpdate', (event) => {
		const retailerId = event?.detail?.id ? event.detail.id : getCookie('retailerID');
		applyForRetailerId(retailerId);
	});

	document.addEventListener('retailerUpdated', (event) => {
		const retailerId = event?.detail?.id ? event.detail.id : getCookie('retailerID');
		applyForRetailerId(retailerId);
	});
}

if (typeof document !== 'undefined') {
	document.addEventListener('DOMContentLoaded', initNavLocationCategories);
}
